import { DependencyList, useEffect } from 'react';

/**
 * Gebruik deze custom hook om een keer per sessie een effect uit te voeren op het moment
 * dat alle dependencies truthy zijn geworden.
 *
 * Dit is handig als we eenmalig iets willen loggen in de backend, bijv. na inloggen.
 *
 */
const useRunOncePerSession = (effect: () => void, sessionKey: string, deps?: DependencyList) => {
  useEffect(() => {
    const hasBeenTriggered = JSON.parse(sessionStorage.getItem(sessionKey) ?? 'false') === true;
    if (!hasBeenTriggered) {
      const allDepsAreTruthy = deps?.every((d) => d);
      if (allDepsAreTruthy) {
        effect.apply(null);
        sessionStorage.setItem(sessionKey, 'true');
      }
    }
  }, [deps, effect, sessionKey]);

  return null;
};

export default useRunOncePerSession;
